import { Button } from "@/components/ui/button";
import { InvoiceDialog } from "./InvoiceDialog";
import { SendBidDialog } from "./SendBidDialog";
import { Loading } from "@/components/ui/loading";
import { Info } from "lucide-react";

interface BidFormActionsProps {
  onSave: () => void;
  onSendInvoice: () => void;
  onSendBid: () => void;
  onCreateEvent: () => void;
  loading?: boolean;
}

export function BidFormActions({
  onSave,
  onSendInvoice,
  onSendBid,
  onCreateEvent,
  loading,
}: BidFormActionsProps) {
  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className="space-y-6">
          <div className="bg-secondary/30 p-4 rounded-lg border border-border">
            <div className="flex items-start gap-3">
              <Info className="w-5 h-5 text-foreground mt-0.5 flex-shrink-0" />
              <div className="text-sm text-foreground space-y-2">
                <p className="font-medium text-foreground">Button Functions:</p>
                <ul className="space-y-1.5">
                  <li>
                    <span className="font-medium text-foreground">
                      Create Event:
                    </span>{" "}
                    Creates the event but does NOT send a Stripe invoice (use if
                    client has already paid or if this is a free event)
                  </li>
                  <li>
                    <span className="font-medium text-foreground">Save:</span>{" "}
                    Saves the current data (use if client is not ready to be
                    sent an invoice)
                  </li>
                  <li>
                    <span className="font-medium text-foreground">
                      Send Bid:
                    </span>{" "}
                    Emails the client a bid with the tables, quantities and
                    pricing (no invoice is created and no payment is requested)
                  </li>
                  <li>
                    <span className="font-medium text-foreground">
                      Send Invoice:
                    </span>{" "}
                    Sends an invoice to customer for payment
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="flex justify-end space-x-4">
            <Button
              type="button"
              variant="secondary"
              onClick={onCreateEvent}
              disabled={loading}
            >
              Create Event
            </Button>
            <Button type="button" onClick={onSave} disabled={loading}>
              Save
            </Button>
            <SendBidDialog onSendBid={onSendBid} loading={loading} />
            <InvoiceDialog onSendInvoice={onSendInvoice} loading={loading} />
          </div>
        </div>
      )}
    </>
  );
}
